import client from "@https/api";
import type {
    IRamadanRiddlesResponse,
    IRamadanRiddleQuestionResponse,
    IRamadanRiddleSubmitRequest,
    IRamadanRiddleSubmitResponse,
    IRamadanRiddleRewardsResponse,
} from "@types";
import gate from "../gate";

const ramadanRiddlesApi = {
    getOverview: () =>
        gate.get<IRamadanRiddlesResponse, never, never>({
            client,
            url: "ramadan-riddles",
        }),

    getQuestion: () =>
        gate.get<IRamadanRiddleQuestionResponse, never, never>({
            client,
            url: "ramadan-riddles/question",
        }),

    submitQuestion: (data: IRamadanRiddleSubmitRequest) =>
        gate.post<IRamadanRiddleSubmitResponse, IRamadanRiddleSubmitRequest, never>({
            client,
            url: "ramadan-riddles/question/submit",
            data,
        }),

    getRewards: () =>
        gate.get<IRamadanRiddleRewardsResponse, never, never>({
            client,
            url: "ramadan-riddles/rewards",
        }),
};

export default ramadanRiddlesApi;
